var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _path12, _path13, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendMessagesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 63,
    viewBox: "0 0 62 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9276 63L1.35723 31.5362C0.494601 30.7732 0.00271468 29.6754 0.00745288 28.5237L0.078858 11.1679C0.0879203 8.96522 1.87611 7.18437 4.07882 7.18437L23.5495 7.18437L62 41.1957",
    fill: "#3386FD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.5527,
    y: 17.7161,
    width: 42.9789,
    height: 30.5677,
    fill: "#003C8B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5721 17.748H15.9907C15.9907 7.94799 24.9128 0 35.9172 0H37.2037L40.9525 0.0559999C51.3465 0.657999 59.5744 8.33799 59.5721 17.748Z",
    fill: "#003C8B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6566 36.512H0.125C0.125 46.3439 9.10686 54.3119 20.1878 54.3119H40.91L59.6566 54.2539C59.6566 36.512 59.6566 45.9519 59.6566 36.512Z",
    fill: "#1760CE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0245 41.395H23.5146V43.533H44.0245V41.395Z",
    fill: "#1760CE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0441 5.64307H20.2319C18.0228 5.64307 16.2319 7.43393 16.2319 9.64307V46.3387C16.2319 48.5479 18.0228 50.3387 20.2319 50.3387H43.0441C45.2533 50.3387 47.0441 48.5479 47.0441 46.3387V9.64307C47.0441 7.43393 45.2533 5.64307 43.0441 5.64307Z",
    fill: "#003C8B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1247 5.64307H17.3125C15.1034 5.64307 13.3125 7.43392 13.3125 9.64306V44.2838C13.3125 46.4929 15.1034 48.2838 17.3125 48.2838H40.1247C42.3338 48.2838 44.1247 46.4929 44.1247 44.2838V9.64307C44.1247 7.43393 42.3338 5.64307 40.1247 5.64307Z",
    fill: "#EDF4FC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1523 7.18433H16.2861C15.1816 7.18433 14.2861 8.07976 14.2861 9.18433V43.2013C14.2861 44.3059 15.1816 45.2013 16.2861 45.2013H41.1523C42.2569 45.2013 43.1523 44.3059 43.1523 43.2013V9.18433C43.1523 8.07976 42.2569 7.18433 41.1523 7.18433Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8229 29.7891H23.3447C22.999 29.7891 22.7188 30.0693 22.7188 30.4151C22.7188 30.7608 22.999 31.0411 23.3447 31.0411H31.8229C32.1686 31.0411 32.4489 30.7608 32.4489 30.4151C32.4489 30.0693 32.1686 29.7891 31.8229 29.7891Z",
    fill: "#DAEAFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4014 16.9456H20.7662C20.4115 16.9456 20.124 17.2331 20.124 17.5877C20.124 17.9424 20.4115 18.2299 20.7662 18.2299H34.4014C34.7561 18.2299 35.0436 17.9424 35.0436 17.5877C35.0436 17.2331 34.7561 16.9456 34.4014 16.9456Z",
    fill: "#DAEAFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4014 23.5688H20.7662C20.4115 23.5688 20.124 23.8564 20.124 24.211C20.124 24.5657 20.4115 24.8532 20.7662 24.8532H34.4014C34.7561 24.8532 35.0436 24.5657 35.0436 24.211C35.0436 23.8564 34.7561 23.5688 34.4014 23.5688Z",
    fill: "#DAEAFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1797_3047",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 26,
    width: 28,
    height: 21
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49405 46.866L7.33886 46.4175L7.18862 42.787L4.82497 42.3838L3.70651 39.5501L23.9491 26.8133L26.2755 27.3709L26.039 28.9577L28.4944 29.3855L28.5297 31.3782L30.7443 31.4952L30.7129 33.3687L9.49405 46.866Z",
    fill: "#C87F3B"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1797_3047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.84504 42.3603L26.0389 28.9577L27.1117 27.7113L24.2279 25.0259L2.1007 40.1033L4.84504 42.3603Z",
    fill: "#003C8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.15186 44.7324L28.3457 31.3297L30.2098 30.7548L28.6685 28.8884L25.8885 28.9488L4.68747 42.4781L7.15186 44.7324Z",
    fill: "#1760CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.19111 48.1796L31.0549 33.693L32.2133 32.3472L29.646 30.4576L5.53981 45.752L8.19111 48.1796Z",
    fill: "#3388FF"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6929 33.3923L37.719 23.5244L23.9495 26.8134L26.203 27.3647L25.8892 28.9482L28.426 29.4142L28.3604 31.4408L30.5739 31.5511L30.6929 33.3923Z",
    fill: "url(#paint0_linear_1797_3047)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0712 25.8325L34.3028 24.3442L37.7191 23.5245L36.0712 25.8325Z",
    fill: "#003C8B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1797_3047",
    x1: 27.9908,
    y1: 25.5316,
    x2: 34.2332,
    y2: 29.1107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3388FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9762,
    stopColor: "#7FB5FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessagesIcon);
export default __webpack_public_path__ + "static/media/send_messages_icon.b948609b.svg";
export { ForwardRef as ReactComponent };